import { FC } from 'react'
import { useForm, FormProvider, FormProviderProps, useFormContext } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { ITransactionSetWithSubtype } from 'types/graphqlTypes'
import { object, string } from 'yup'

interface ITransactionSetWithSubtypeSchema {
  transactionSetWithSubtype: string
}

const TransactionSetWithSubtypeSchema = object<ITransactionSetWithSubtypeSchema>({
  transactionSetWithSubtype: string(),
})

export const useShipperConfigForm = () => {
  return useForm<ITransactionSetWithSubtype>({
    resolver: yupResolver(TransactionSetWithSubtypeSchema),
    mode: 'onChange',
  })
}

export const ShipperConfigFormProvider: FC<FormProviderProps<
  ITransactionSetWithSubtype
>> = FormProvider

export const useShipperConfigFormContext = () => useFormContext<ITransactionSetWithSubtype>()
